// extracted by mini-css-extract-plugin
module.exports = {"dummySelect":"DummySelect_dummySelect__5ZHZC","deprecateTag":"DummySelect_deprecateTag__HeuKo","labelText":"DummySelect_labelText__rdDrP"};